export default {
  isLoggedIn: false,
  user: {
  },
  sideBarmenuIsOpen: false,
  entidadesVisibles: false,
  entidadesVisiblesRelated: false,
  isAdminEntidad: false,
  isDeliveryUser: false
};
